import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { ArrowUpRight } from 'lucide-react';
import { SectionHeading } from './ui-kit/SectionHeading';
import { Reveal } from './ui-kit/Reveal';
import { BrandButton } from './ui-kit/BrandButton';

const AboutTeaser = () => {
  const { t, language } = useLanguage();
  return (
    <section id="about" className="py-24 md:py-32 bg-bg" data-testid="about-teaser-section">
      <div className="container-page grid md:grid-cols-12 gap-10 items-start">
        <div className="md:col-span-6">
          <SectionHeading
            eyebrow={t.about.subtitle}
            title={t.about.title}
            lead={t.about.description}
          />
          <Reveal delay={180}>
            <p className="mt-5 text-body text-ink-muted max-w-xl">{t.about.description2}</p>
          </Reveal>
          <Reveal delay={240}>
            <div className="mt-9">
              <BrandButton to="/meista" variant="secondary" iconRight={ArrowUpRight}>
                {language === 'fi' ? 'Tutustu tiimiin' : 'Meet the team'}
              </BrandButton>
            </div>
          </Reveal>
        </div>

        {/* Quote card */}
        <Reveal delay={120} className="md:col-span-6">
          <figure className="rounded-card bg-surface border border-line p-8 md:p-10">
            <svg className="text-brand" width="28" height="22" viewBox="0 0 28 22" fill="currentColor" aria-hidden>
              <path d="M0 22V12C0 5.4 4.2 0.8 11 0L12 3.6C8.4 4.4 6.2 7 6 10H10V22H0ZM16 22V12C16 5.4 20.2 0.8 27 0L28 3.6C24.4 4.4 22.2 7 22 10H26V22H16Z"/>
            </svg>
            <blockquote className="mt-6 text-[20px] md:text-[22px] leading-[1.45] text-ink">
              {language === 'fi'
                ? 'Verkkosivu ei ole staattinen esite. Se on käyttöliittymä, joka voi puhua, ohjata ja konvertoida — kun sen rakentaa huolella.'
                : 'A website isn’t a static brochure. It’s an interface that can talk, guide and convert — when built with care.'}
            </blockquote>
            <figcaption className="mt-7 flex items-center gap-3">
              <span className="inline-flex h-9 w-9 items-center justify-center rounded-pill bg-ink text-white text-[12px] font-semibold">LM</span>
              <div className="text-[13.5px]">
                <div className="text-ink font-medium">Lenni Marttila</div>
                <div className="text-ink-muted">{language === 'fi' ? 'Yhteisperustaja, Agencive AI' : 'Co-founder, Agencive AI'}</div>
              </div>
            </figcaption>
          </figure>
        </Reveal>
      </div>
    </section>
  );
};

export default AboutTeaser;
